export const ALERT_SUCCESS = '@alert/ALERT_SUCCESS';
export const ALERT_ERROR = '@alert/ALERT_ERROR';
export const ALERT_CLEAR = '@alert/ALERT_CLEAR';
export const ALERT_ERROR_WRAP = '@alert/ALERT_ERROR_WRAP';
